import { c as _c } from "react/compiler-runtime";
import Button from '../../base/Button';
import Text from '../../base/Text';
import SelectInput from '../../Form/Fields/SelectInput';
import { Div } from '../../helpers/StyledUtils';
const SelectFilter: React.FC<{
  delete_button?: JSX.Element;
  title?: string;
  placeholder?: string;
  in_dropdown?: boolean;
  hide_search?: boolean;
  onBack?: () => void;
  onSubmit: () => void;
  name: string;
  options: {
    label: string;
    value: string;
  }[];
  block?: boolean;
}> = t0 => {
  const $ = _c(16);
  const {
    options,
    name,
    title,
    in_dropdown,
    onBack
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: 3,
      direction: "column"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      align: "center",
      gap: 3
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== in_dropdown || $[3] !== onBack) {
    t3 = in_dropdown ? <Button outline={true} small={true} icon="arrow_back" onClick={onBack} /> : null;
    $[2] = in_dropdown;
    $[3] = onBack;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = title || "Filter by " + name;
  let t5;
  if ($[5] !== t4) {
    t5 = <Text semi={true}>{t4}</Text>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = <Div flex={t2}>{t3}{t5}</Div>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== name || $[11] !== options) {
    t7 = <SelectInput name={name} options={options} block={true} m={0} />;
    $[10] = name;
    $[11] = options;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <Div><Div p={3} flex={t1}>{t6}{t7}</Div></Div>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
export default SelectFilter;